import React, { useState, useEffect, useCallback } from "react";
import { getRemainingTime } from "../authorization/TimeMethods";

let logoutTimer;

const AuthContext = React.createContext({
  token: "",
  isLoggedIn: false,
  isReadOnly: false,
  esriFeatureLayerFilters: {},
  user: {},
  login: () => {},
  logout: () => {},
});

// Return session storage user data .
const retrieveStoredUser = () => {
  const storedToken = sessionStorage.getItem("token");
  const storedExpirationDate = sessionStorage.getItem("expirationTime");
  const remainingTime = getRemainingTime(storedExpirationDate);
  const storedUser = JSON.parse(sessionStorage.getItem("user"));

  // 1 min = 60k milliseconds
  if (remainingTime <= 60000) {
    sessionStorage.clear();
    return null;
  }

  return {
    token: storedToken,
    duration: remainingTime,
    user: storedUser,
  };
};

export const AuthContextProvider = (props) => {
  const tokenData = retrieveStoredUser();
  let initialToken;
  let initialUser;
  if (tokenData) {
    initialToken = tokenData.token;
    initialUser = tokenData.user;
  }
  const [token, setToken] = useState(initialToken);
  const [user, setUser] = useState(initialUser);
  const userIsLoggedIn = !!token;

  const logoutHandler = useCallback(() => {
    setToken(null);
    sessionStorage.clear();

    if (logoutTimer) {
      clearTimeout(logoutTimer);
    }
  }, []);

  const saveUserObject = (props) => {
    let userObj = {
      displayName: props?.displayName || null,
      email: props?.email || null,
      username: props?.username || null,
      groupMemberships: props?.groupMemberships || null,
      filters: props?.esriFeatureLayerFilters,
    };
    setUser(userObj);
    sessionStorage.setItem("user", JSON.stringify(userObj));
  };

  const loginHandler = (props) => {
    setToken(props.token);
    saveUserObject(props);
    const remainingTime = getRemainingTime(props.expirationTime);
    logoutTimer = setTimeout(logoutHandler, remainingTime);
    sessionStorage.setItem("token", props.token);
    sessionStorage.setItem("expirationTime", props.expirationTime);
  };

  useEffect(() => {
    if (tokenData) {
      logoutTimer = setTimeout(logoutHandler, tokenData.duration);
    }
  }, [tokenData, logoutHandler]);

  const contextValue = {
    token: token,
    isLoggedIn: userIsLoggedIn,
    isReadOnly: user?.groupMemberships?.includes("COLLECTOR_USER_READONLY"),
    user: user,
    login: loginHandler,
    logout: logoutHandler,
  };

  return (
    <AuthContext.Provider value={contextValue}>
      {props.children}
    </AuthContext.Provider>
  );
};

export default AuthContext;
